export default "__VITE_ASSET__CpybtfWf__"